import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme from 'theme/theme';
import {
  AlertCircleIcon,
  InfoCircleIcon,
} from '../Icon';
import MainTitle from '../MainTitle';
import Flex from '../Flex';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 45px 20px 90px;
  background: ${theme.colors.medium};
  color: #fff;
  border-bottom: 1px solid #fff;
  
  &:last-child {
    border-bottom: 0;
  }
  
  .icon {
    position: absolute;
    left: 45px;
    top: 23px;
  }
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 15px 15px 15px 70px;
  }
  @media (max-width: ${theme.breakpoints.desktopLarge}) {
    padding: 15px 15px 15px 55px;
    .icon {
      left: 20px;
      top: 15px;
    }
  }
  
  @media print {
    padding: 10px 0;
    min-height: 0;
    background: none;
    color: #000;
  }
  
  ${(props) => props.type === 'warning' && css`
    background: ${theme.colors.primary};
    ${MainTitle} {
      color: #fff;
    }
  `}

}
`;

const getIcon = (type) => {
  switch (type) {
    case 'warning':
      return <AlertCircleIcon inlineLeft className="icon" />;
    default:
      return <InfoCircleIcon inlineLeft className="icon" />;
  }
};

const HeaderMessage = ({
  type, title, message, style,
}) => (
  <Wrapper style={style} type={type}>
    <Flex flexDirection="column">
      <MainTitle>
        {getIcon(type)}
        {title}
      </MainTitle>
      {message && <div>{message}</div>}
    </Flex>
  </Wrapper>
);
HeaderMessage.propTypes = {
  type: PropTypes.oneOf(['info', 'warning']),
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  style: PropTypes.objectOf(PropTypes.any),
};
HeaderMessage.defaultProps = {
  type: 'info',
  message: [],
  style: {},
};

export default HeaderMessage;
